/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  ImagesControllerCreateMutationRequest,
  ImagesControllerCreateMutationResponse,
  ImagesControllerCreate401,
} from '../types/ImagesControllerCreate.ts';

function getImagesCreateUrl() {
  const res = { method: 'POST', url: `/api/images` as const };
  return res;
}

/**
 * {@link /api/images}
 */
export async function imagesCreate(
  data: ImagesControllerCreateMutationRequest,
  config: Partial<RequestConfig<ImagesControllerCreateMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = new FormData();
  if (requestData) {
    Object.keys(requestData).forEach((key) => {
      const value = requestData[key as keyof typeof requestData];
      if (typeof value === 'string' || (value as unknown) instanceof Blob) {
        formData.append(key, value as unknown as string | Blob);
      }
    });
  }
  const res = await request<
    ImagesControllerCreateMutationResponse,
    ResponseErrorConfig<ImagesControllerCreate401>,
    ImagesControllerCreateMutationRequest
  >({
    method: 'POST',
    url: getImagesCreateUrl().url.toString(),
    data: formData,
    ...requestConfig,
    headers: { 'Content-Type': 'multipart/form-data', ...requestConfig.headers },
  });
  return res.data;
}
